import { usePersistedRoadmapControls } from '@griply/hooks';
import { RoadmapPlatform, RoadmapViewSettings } from '@griply/types';
import { useUpdateLifeArea } from 'features/life-areas';
import { useCallback } from 'react';
import { useToday } from 'shared/contexts/today';
import { LifeArea } from 'shared/types/life-area';

export const useLifeAreaRoadmapControls = (lifeArea: LifeArea | undefined) => {
  const today = useToday();
  const { submit: updateLifeArea } = useUpdateLifeArea();
  const lifeAreaId = lifeArea?.id;

  const onUpdateRoadmap = useCallback(
    (roadmap: RoadmapViewSettings) => {
      if (!lifeAreaId) {
        return;
      }
      updateLifeArea({ id: lifeAreaId, roadmap });
    },
    [lifeAreaId, updateLifeArea],
  );

  return usePersistedRoadmapControls({
    roadmap: lifeArea?.roadmap,
    onUpdateRoadmap,
    today,
    platform: RoadmapPlatform.Web,
  });
};
